export default __webpack_public_path__ + "static/media/IMG_20230606_160930_121.5fcf1d80.jpg";